/**
 * Navigation selection helpers extracted from Navigation.vue
 * to keep the component focused on rendering and interaction.
 */

export const fallbackToDashboard = ({ reportId, reportKey, searchEndpoint }) => {
  const dashboardOption = searchEndpoint.items.find((option) => option.dataType === 'custom')

  if (dashboardOption) {
    return {
      ...dashboardOption,
      error: false,
      fallbackToDashboard: true,
      originalReportId: reportId,
      reportKey,
    }
  }

  return { error: 404, message: 'Dashboard Option Not Found' }
}

export const findSelectedSearch = async ({
  dispatch,
  navigationOptions,
  nav,
  searchResults,
}) => {
  const { params, reportKey, routeName } = nav
  const { reportName, reportId, subId } = params

  if (!searchResults) {
    return { error: 404, message: 'Search Options Not Found' }
  }

  if (!searchResults.endpoints) {
    return { error: 404, message: 'Search Endpoints Not Found' }
  }

  const searchEndpoint = searchResults.endpoints[reportKey]
  const navigationOption = navigationOptions.find((option) => option.reportKey === reportKey)

  if (!searchEndpoint) {
    return { error: 404, message: 'Search Endpoint Not Found' }
  }

  if (!searchEndpoint.items) {
    return { error: 404, message: 'Search Items Not Found' }
  }

  if (Array.isArray(searchEndpoint.items)) {
    const isAllowedNavOption = navigationOption && navigationOption.hasAccess === true

    if (!isAllowedNavOption) {
      return fallbackToDashboard({ reportId, reportKey, searchEndpoint })
    }

    return { error: 404, message: 'Invalid Search Items' }
  }

  const fuseInstance = searchEndpoint.items

  if (!fuseInstance) {
    return { error: 404, message: 'Search Instance Error' }
  }

  const searchCollection = fuseInstance.list

  if (!Array.isArray(searchCollection)) {
    return { error: 404, message: 'Invalid Search Collection' }
  }

  const foundSelection = await dispatch('tools/findSelectedSearch', {
    reportId,
    reportName,
    routeName,
    searchCollection,
    subId,
  })

  if (!foundSelection && reportId && searchCollection.length > 0) {
    const dashboardOption = searchCollection.find((option) => option.dataType === 'custom')

    if (dashboardOption) {
      return {
        ...dashboardOption,
        error: false,
        fallbackToDashboard: true,
        originalReportId: reportId,
        reportKey,
      }
    }
  }

  return foundSelection
}

export const selectSearchItem = async ({
  $route,
  commit,
  dispatch,
  nav,
  searchResults,
}) => {
  const { reportKey } = nav

  if (!searchResults || !searchResults.endpoints || !searchResults.endpoints[reportKey]) {
    const message = `Navigation to ${nav.title} failed: Endpoint not configured`

    commit('tools/snackbar', true)
    commit('tools/snack', { message, status: 'error' })

    return false
  }

  const endpoint = searchResults.endpoints[reportKey]
  const dashboardOption = endpoint.items ? endpoint.items.find((item) => item.dataType === 'custom') : null

  if (!dashboardOption) {
    const message = `Navigation to ${nav.title} failed: Dashboard option not found`

    commit('tools/snackbar', true)
    commit('tools/snack', { message, status: 'error' })

    return false
  }

  await dispatch('tools/selectSearchItem', {
    $route,
    selection: dashboardOption,
  })

  return true
}
